import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ListAdminButtons from "../../Common/ListAdminButtons";
import ActionModal from "../../Common/ActionModal";
import ResultModal from "../../Common/ResultModal";
import { handoverService } from "../../../Services/AccountingServices/handover.service";
import { AuthContext } from "../../../Contexts/AuthContext";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useHistory } from "react-router-dom";
import moment from "moment";
import DocumentsTable from "./DocumentsTable";
import SearchForm from "./SearchForm";

const Handover = () => {
  const { t: translator } = useTranslation();
  const history = useHistory();
  const {
    updateLocName,
    updateLocTenant,
    updateLocStore,
    updateLocPos,
    updateLocTab,
    updateLocKey,
  } = useContext(GlobalContext);
  const { useAccounting } = useContext(AuthContext);

  const [update, setUpdate] = useState(new Date());
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);
  const [documentNumber, setDocumentNumber] = useState("");

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    searchText: "",
    sortName: "DocumentDate",
    storeId: 0,
    isAsc: true,
    dateFrom: null,
    dateTo: null,
  });

  const [actionModal, setActionModal] = useState({
    title: "",
    text: "",
    show: false,
    confirmBtn: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const handleClose = () => {
    setModal({ show: false });
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    updateLocName("handover");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
    updateLocKey(0);

    var m = moment();
    var dateTo = moment(search.dateTo);
    m.set(dateTo.toObject());

    handoverService
      .documentSearch(
        search.tenantId,
        search.searchText,
        pagination.pageIndex,
        pagination.pageSize,
        search.sortName,
        search.isAsc,
        search.storeId,
        search.dateFrom,
        dateTo.endOf("day"),
      )
      .then((res) => {
        console.log(res);
        setDocuments(res?.data?.data || []);
        setPagination({ ...pagination, totalCount: res.data.totalCount });
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [update, search]);

  const handleToAdd = () => {
    history.push("/handover-create");
  };

  const handleToDetail = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/handover-details/${selectedItems}`);
  };

  const handleDelete = () => {
    setActionModal({
      title: "InitialState-DocumentDelete-Title",
      text: "InitialState-DocumentDelete-Text",
      confirmBtn: "Confirm-Delete",
      confirmAction: confirmDelete,
      show: true,
    });
  };

  const handleHideActionModal = () =>
    setActionModal({ ...actionModal, show: false });

  const confirmDelete = () => {
    let deletePromises = [];
    selectedItems.forEach((x) => {
      deletePromises.push(handoverService.documentDelete(x));
    });
    Promise.all(deletePromises)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        if (data[0].data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteSuccess-Title",
            text: "InitialState-ResultModal-DeleteSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
          setSelectedItems([]);
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-DeleteError-Title",
            text: translator(data[0].data.message),
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "InitialState-ResultModal-DeleteError-Title",
          text: "InitialState-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
        }),
      );
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Main-Sidebar-Handover")} </span>
          {"  "}
          {!isLoading ? (
            <span className="badge badge-pill badge-primary">
              {pagination.totalCount}
            </span>
          ) : null}
        </div>
        <div className="card-body">
          <SearchForm
            search={search}
            setSearch={setSearch}
            pagination={pagination}
            setPagination={setPagination}
            setIsLoading={setIsLoading}
          />
          <ListAdminButtons
            handleToAdd={handleToAdd}
            handleToDetail={handleToDetail}
            handleDelete={handleDelete}
            selectedItemsLength={selectedItems.length}
            documentNumber={documentNumber}
          />
          <DocumentsTable
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            search={search}
            setSearch={setSearch}
            pagination={pagination}
            setPagination={setPagination}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            documents={documents}
            setDocumentNumber={setDocumentNumber}
            setUpdate={setUpdate}
          />
        </div>
      </div>
      <ActionModal
        show={actionModal.show}
        handleHide={handleHideActionModal}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </div>
  );
};

export default Handover;
